import React from "react";
import { useTranslation } from "react-i18next";

const APP_VERSION = "v0.1.0";

export default function Footer() {
    const { t } = useTranslation();

    const cols = [
        {
            title: t("landing.footer.product"),
            links: [
                { label: t("landing.footer.linkHowItWorks"), href: "#how" },
                { label: t("landing.footer.linkFeatures"), href: "#features" },
                { label: t("landing.footer.linkPricing"), href: "#pricing" },
                { label: t("landing.footer.linkChromeExtension"), href: "#", featured: true },
            ],
        },
        {
            title: t("landing.footer.legal"),
            links: [
                { label: t("landing.footer.linkPrivacy"), href: "/privacy" },
                { label: t("landing.footer.linkTerms"), href: "/terms" },
            ],
        },
    ];

    return (
        <footer
            className="bg-white text-black"
            data-testid="site-footer"
        >
            {/* Link grid */}
            <div className="border-b-2 border-black">
                <div className="mx-auto max-w-[1400px] grid grid-cols-2">
                    {cols.map((c, i) => (
                        <div
                            key={c.title}
                            className={`p-8 md:p-10 ${i < cols.length - 1 ? "border-r-2 border-black" : ""}`}
                        >
                            <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-4">
                                {c.title}
                            </div>
                            <ul className="space-y-2">
                                {c.links.map(({ label, href, featured }) => (
                                    <li key={label}>
                                        {featured ? (
                                            <a
                                                href={href}
                                                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-").replace(/\//g, "-")}`}
                                                className="inline-flex items-center gap-1 px-3 py-1.5 bg-black text-white font-mono text-sm font-bold hover:bg-zinc-700 transition-colors"
                                            >
                                                {label} →
                                            </a>
                                        ) : (
                                            <a
                                                href={href}
                                                data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-").replace(/\//g, "-")}`}
                                                className="font-mono text-sm hover:underline underline-offset-4"
                                            >
                                                {label} →
                                            </a>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* Massive brand */}
            <div className="border-b-2 border-black overflow-hidden">
                <div className="font-display text-[18vw] md:text-[15vw] leading-[0.85] uppercase tracking-tighter px-2 select-none">
                    SPOTCAR.
                </div>
            </div>

            {/* Bottom row */}
            <div className="mx-auto max-w-[1400px] grid grid-cols-12 px-6 py-5 gap-4 items-center">
                <div className="col-span-12 md:col-span-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 flex items-center gap-3">
                    {t("landing.footer.copyright", { year: new Date().getFullYear() })}
                    <span className="text-zinc-400">{APP_VERSION}</span>
                </div>
                <div className="col-span-12 md:col-span-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 text-center">
                    {t("landing.footer.tagline")}
                </div>
                <div className="col-span-12 md:col-span-4 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600 md:text-right flex md:justify-end items-center gap-2">
                    <span className="h-2 w-2 bg-[#34C759] inline-block" />
                    {t("landing.footer.status")}
                </div>
            </div>
        </footer>
    );
}
